/* eslint-disable @typescript-eslint/no-empty-function */
export type NoOpFn = typeof noOpFn;
export type NoOpFnReturningNull = typeof noOpFnReturningNull;
export type AsyncNoOpFn = typeof asyncNoOpFn;
export type AsyncOrSyncNoOpFn = AsyncNoOpFn | NoOpFn;

export const noOpFn = (): void => {};
export const noOpFnReturningNull = (): null => null;
export const asyncNoOpFn = async (): Promise<void> => {};
